import React from 'react';
import CHANGELOG from '../data/changelog';
import { APP_VERSION } from '../version';
import { fmtDate } from '../utils/date';

const TYPE_LABELS = { feature: 'New', improvement: 'Improved', fix: 'Fixed', security: 'Security' };

export default function Releases() {
  return (
    <div>
      <h1>Releases</h1>
      <p className="release-running">Running version <strong>v{APP_VERSION}</strong></p>
      {CHANGELOG.map(r => (
        <section key={r.version} className="release-card">
          <div className="release-head">
            <span className="release-version">v{r.version}</span>
            {r.version === APP_VERSION && <span className="release-current">Current</span>}
            <span className="release-title">{r.title}</span>
            <span className="release-date">{fmtDate(r.date)}</span>
          </div>
          <ul className="release-changes">
            {r.changes.map((c, i) => (
              <li key={i}>
                <span className={`release-tag release-tag-${c.type}`}>{TYPE_LABELS[c.type] || c.type}</span>
                {c.text}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
